import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { ConfirmTrashCallable } from "@/action-dialog/callables";
import { showMovedToTrashToast } from "@/components/ConfirmTrashDialog/movedToTrashToast";
import type { Skill } from "@cohesive/api-client";
import toast from "react-hot-toast";

export interface MoveSkillToTrashParams {
  skill: Skill;
  deleteSkill: {
    mutate: (
      skillId: string,
      options?: {
        onSuccess?: () => void;
        onError?: () => void;
      },
    ) => void;
  };
  restoreSkill: {
    mutate: (
      params: { skillId: string },
      options?: { onError?: (err: unknown) => void },
    ) => void;
  };
  onRestoreError?: (err: unknown) => void;
  /** Extra side effects after a successful trash (toast is always shown). */
  onSuccess?: (skill: Skill) => void | Promise<void>;
}

export function runMoveSkillToTrashWorkflow(
  params: MoveSkillToTrashParams,
): Promise<boolean> {
  const { skill, deleteSkill, restoreSkill, onRestoreError, onSuccess } =
    params;

  return withActionDialogLock(() =>
    ConfirmTrashCallable.call({
      kind: "skill",
      name: skill.name,
      mutationFn: async (call) => {
        await new Promise<void>((resolve, reject) => {
          deleteSkill.mutate(skill.id, {
            onSuccess: () => resolve(),
            onError: () => {
              toast.error("Failed to archive skill.");
              reject(new Error("delete failed"));
            },
          });
        });
        showMovedToTrashToast(() =>
          restoreSkill.mutate(
            { skillId: skill.id },
            { onError: onRestoreError },
          ),
        );
        await onSuccess?.(skill);
        call.end(true);
      },
    }),
  );
}
